import { useState } from 'react';
import { ClipboardCheck } from 'lucide-react';
import { parseJsonInput } from '../utils/json';
import { validateLessonJson } from '../prompts/schema';
export default function JsonImporter({ onValid }) {
  const [raw, setRaw] = useState('');
  const [errors, setErrors] = useState([]);
  function parse() {
    try { const parsed = parseJsonInput(raw); const result = validateLessonJson(parsed); setErrors(result.errors); if (result.valid) onValid(parsed); }
    catch (error) { setErrors([error.message]); }
  }
  return <section className="panel"><div className="section-title"><ClipboardCheck size={20} /><h2>Paste LLM JSON</h2></div><textarea className="json-box" value={raw} onChange={(event) => setRaw(event.target.value)} placeholder="Paste the strict JSON response here." /><button className="primary" onClick={parse}>Validate and load</button>{errors.length > 0 && <ul className="error-list">{errors.map((error) => <li key={error}>{error}</li>)}</ul>}</section>;
}
